import * as React from "react";
import { entities } from "sb-bff-integration";
import { getPropertyValueOrDefault } from "../../../../helpers";
export class GameItem extends React.PureComponent {
    render() {
        let gameTime = this.props.game.gamePart === entities.GamePart.BreakAfterFirstHalf ? "" : `${this.props.game.gameTime}'`;
        let gameStatus = `${getPropertyValueOrDefault(this.props.dict, this.props.game.gamePart)} ${gameTime}`;
        return (React.createElement("div", { className: "rj-aggregate-matches-item" },
            React.createElement("div", { className: "rj-aggregate-match-participant1" }, this.props.game.participant1.name),
            React.createElement("div", { className: "rj-aggregate-match-scores" },
                React.createElement("span", { className: "rj-aggregate-match-participant-name" }, this.props.game.participant1.score),
                React.createElement("span", { className: "rj-aggregate-match-scores--separator" }, "-"),
                React.createElement("span", null, this.props.game.participant2.score)),
            React.createElement("div", { className: "rj-aggregate-match-participant2" },
                React.createElement("span", { className: "rj-aggregate-match-participant-name" }, this.props.game.participant2.name),
                React.createElement("span", { className: "rj-aggregate-match-time" }, gameStatus))));
    }
}
//# sourceMappingURL=GameItem.js.map